module.exports = __webpack_public_path__ + "img/login-back.941fcc7e.jpeg";